import { inject, Injectable } from '@angular/core';
import { BackendDataSourceService, ViewData } from '@ntap/core';
import {
  BehaviorSubject,
  map,
  Observable,
  shareReplay,
  skip,
  switchMap
} from 'rxjs';
import {
  ObrazacUnosaDropdownOption,
  ObrazacUnosaDTO
} from './obrazac-unosa.service';

@Injectable({
  providedIn: 'root'
})
export class ObrasciUnosaStore {
  entryTemplates$: Observable<Array<ObrazacUnosaDTO>>;

  entryTemplateDropdownOptions$: Observable<Array<ObrazacUnosaDropdownOption>>;

  private backendService = inject(BackendDataSourceService);

  private refreshEntryTemplatesSubject = new BehaviorSubject(true);

  constructor() {
    this.initEntryTemplatesObservable();
  }

  initEntryTemplatesObservable() {
    this.entryTemplates$ = this.refreshEntryTemplatesSubject.pipe(
      switchMap(() => {
        return this.backendService
          .getViewData('odabir_obrasca_opisa_gradiva', {})
          .pipe(map((viewData) => viewData as Array<ObrazacUnosaDTO>));
      }),
      shareReplay(1)
    );

    this.entryTemplateDropdownOptions$ = this.entryTemplates$.pipe(
      map((result: ViewData) => this.mapToGroupedDropdownOptions(result))
    );
  }

  private mapToGroupedDropdownOptions(result: ViewData) {
    const data = result as ObrazacUnosaDTO[];
    const groupKeys = data.reduce(
      (
        acc: Record<string, Array<ObrazacUnosaDropdownOption>>,
        curr: ObrazacUnosaDTO
      ) => {
        acc[curr.grupaObrasca] = [];
        return acc;
      },
      {}
    );
    data.forEach((item: ObrazacUnosaDTO) => {
      const data = item as {
        id: number;
        title: string;
        name: string;
        grupaObrasca: string;
      };
      groupKeys[data.grupaObrasca].push({
        label: data.title,
        value: data.id
      });
    });
    return Object.keys(groupKeys).map((key) => {
      return {
        label: key,
        items: groupKeys[key]
      };
    });
  }

  refreshEntryTemplateOptions() {
    this.refreshEntryTemplatesSubject.next(true);
    return this.entryTemplates$.pipe(skip(1));
  }
}
